import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';

import styles from './index.module.scss';

class InternationalizedDropdown extends Component {
  static propTypes = {
    onDatesChange: PropTypes.func.isRequired,
    onIsCustomDate: PropTypes.func.isRequired,
    endDate: PropTypes.string.isRequired,
    showFirstDaysOptions: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    showFirstDaysOptions: false,
  };

  optionsMesssages = defineMessages({
    first30Days: { id: 'dropdown.options-first-30', defaultMessage: 'First 30 days' },
    first90Days: { id: 'dropdown.options-first-90', defaultMessage: 'First 90 days' },
    last7Days: { id: 'dropdown.options-last-7', defaultMessage: 'Last 7 days' },
    last14Days: { id: 'dropdown.options-last-14', defaultMessage: 'Last 14 days' },
    last30Days: { id: 'dropdown.options-last-30', defaultMessage: 'Last 30 days' },
    last90Days: { id: 'dropdown.options-last-90', defaultMessage: 'Last 90 days' },
    allTime: { id: 'dropdown.options-all-time', defaultMessage: 'All time' },
    lastCalendarMonth: { id: 'dropdown.options-last-month', defaultMessage: 'Last calendar month' },
  });

  firstXDaysOptions = [
    {
      count: 29,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.first30Days),
    },
    {
      count: 89,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.first90Days),
    },
  ];

  standardOptions = [
    {
      count: 6,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.last7Days),
    },
    {
      count: 13,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.last14Days),
    },
    {
      count: 29,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.last30Days),
    },
    {
      count: 89,
      unit: 'days',
      text: this.props.intl.formatMessage(this.optionsMesssages.last90Days),
    },
  ];

  get allTimeOption() {
    const labelText = this.props.intl.formatMessage(this.optionsMesssages.allTime);
    const dateRange = {
      startDate: moment('2015-05-01'),
      endDate: moment(this.props.endDate),
      label: labelText,
    };
    return this.generateOption(labelText, dateRange);
  }

  get lastCalendarMonthOption() {
    const labelText = this.props.intl.formatMessage(this.optionsMesssages.lastCalendarMonth);
    const dateRange = {
      startDate: moment()
        .subtract(1, 'months')
        .startOf('month'),
      endDate: moment()
        .subtract(1, 'months')
        .endOf('month'),
      label: labelText,
    };
    return this.generateOption(labelText, dateRange);
  }

  get options() {
    let dropdownOptions;

    if (this.props.showFirstDaysOptions) {
      dropdownOptions = [...this.standardOptions, ...this.firstXDaysOptions];
    } else {
      dropdownOptions = this.standardOptions;
    }

    const options = dropdownOptions.map(({ count, unit, text }) => {
      const dateRange = {
        startDate: moment(this.props.endDate).subtract(count, unit),
        endDate: moment(this.props.endDate),
        label: text,
      };

      return this.generateOption(text, dateRange);
    });

    return [...options, this.lastCalendarMonthOption, this.allTimeOption];
  }

  generateOption(text, dateRange) {
    const Row = 'li';
    return (
      <Row className={styles.row} onClick={() => this.props.onDatesChange(dateRange)} key={text}>
        {text}
      </Row>
    );
  }

  render() {
    const { onIsCustomDate } = this.props;
    const Row = 'li';
    return (
      <ul className={styles.parent} data-qa="date-options-list">
        {this.options}
        <Row className={classNames(styles.row, styles.rowCustom)} onClick={onIsCustomDate}>
          <FormattedMessage id="dropdown.choose" defaultMessage="Choose date range" />
        </Row>
      </ul>
    );
  }
}
const Dropdown = injectIntl(InternationalizedDropdown);
export { Dropdown };
